const gateways = [
  {
    protocol: 'https',
    host: 'ipfs.io',
    apiPath: '/api/v0api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.ipfs.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.infura.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'rx14.co.uk',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ninetailed.ninja',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.globalupload.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.jes.xxx',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'siderus.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'eu.siderus.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'na.siderus.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ap.siderus.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: '10.via0.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.eternum.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'hardbin.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.wa.hle.rs',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.blocksec.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.renehsz.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'cloudflare-ipfs.com',
    apiPath: '/api/v0',
    port: 443,
  },
  { protocol: 'https', host: 'ipns.co', apiPath: '/api/v0', port: 443 },
  {
    protocol: 'https',
    host: 'ipfs.mrh.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.originprotocol.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.pinata.cloud',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.doolta.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.sloppyta.co',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.busy.org',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.greyh.at',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.serph.network',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'jorropo.ovh',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'gateway.temporal.cloud',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.fooock.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'cdn.cwinfo.net',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.privacytools.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.jeroendeneef.com',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'permaweb.io',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.stibarc.gq',
    apiPath: '/api/v0',
    port: 443,
  },
  {
    protocol: 'https',
    host: 'ipfs.best-practice.se',
    apiPath: '/api/v0',
    port: 443,
  },
];

export default gateways;
